import { connect } from 'react-redux';
import AudioElement from 'components/AudioElement/AudioElement';
import _get from 'lodash/get';

function mapStateToProps(state, ownProps) {
  return {
    audioOutputDeviceId: ownProps.audioOutputDeviceId || _get(state, 'app.mediaSettings.speakers')
  };
}

export default connect(mapStateToProps)(AudioElement);
